import request from '@/utils/request'

export default {
    sendPhoneCode: function (phone) {
        return request({
            url: 'happyPotato/sendPhoneCode',
            method: 'post',
            params: {
                phone: phone,
            }
        });
    },
    phoneCodeValidate: function (phone, code) {
        return request({
            url: 'happyPotato/phoneCodeValidate',
            method: 'post',
            params: {
                phone: phone,
                code: code,
            }
        });
    },
    getCouponByJdPin: function (jdPin) {
        return request({
            url: 'happyPotato/getCouponByJdPin',
            method: 'post',
            params: {
                jdPin: jdPin,
            }
        });
    },
}